"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluginManagerProfile = void 0;
exports.pluginManagerProfile = {
    name: 'manager',
    methods: ['getProfile', 'updateProfile', 'activatePlugin', 'deactivatePlugin', 'isActive', 'canCall'],
    events: ['pluginActivated', 'pluginDeactivated', 'profileAdded', 'profileUpdated']
};
//# sourceMappingURL=profile.js.map